module.exports = __webpack_public_path__ + "static/img/people_11.a0578e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/textures/people/people_11.png
// module id = 511
// module chunks = 1